// extracted by mini-css-extract-plugin
export default {"card":"YdG1U","svg":"p_GUU","value":"a6RfN","amazon":"BU68Y","roblox":"ztWyc"};